import React, { useState, useEffect, useMemo } from "react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import Srcset from "./Srcset";
import styles from "../QuickBuyComp/QuickBuyComp.module.scss";
import PopUp from "./ReactPortal/PortalPopUp.js";
import commonStyle from "./common.module.scss";
import SizeGuidePopUp from "./SizeGuidePopUp";
import { getShopifyTagData, getSizeGuideType } from "@/helpers/pdpHelpers";
import { getProductOptions } from "@/helpers/pdpHelpers/pdpVariantHelpers";
import QuickBuyIcon from "@/components/Logos/QuickBuy";
const PLPWishlistMobile = (props) => {
  const {
    data,
    type,
    hexCodeArray,
    productDetails,
    dropdownTitle,
    productImage,
    setOpenOptions,
    openOptions,
    optionName,
    fireWishlistAction,
    wishlistComp
  } = props;
  const [visibility, setVisibility] = useState(openOptions);
  const [selected,setSelected] = useState();
  const [loading,setLoading] = useState();
  const popupCloseHandler = () => {
    document.querySelector("body").classList.remove("disable-scroll");
    setOpenOptions(false);
  };

  const [active, setActive] = useState(false);
  const [buttonCTA, setButtonCTA] = useState('Choose your ' + optionName);

  const selectHandler = (e, ele) => {
    e.preventDefault();
    if (setSelected) setSelected(ele);
    setActive(ele);
  };

  useEffect(() => {
    if (selected) 
    {
      setActive(selected);
      setButtonCTA('Add to wishlist');
    } else {
      let lowerCaseOptionName = optionName.toLowerCase();
      setButtonCTA('Choose your ' + lowerCaseOptionName);
    }
  }, [selected]);

  const tagData = useMemo(
    () => getShopifyTagData(productDetails.tags),
    [productDetails.tags]
  );
  let { sizes } = useMemo(
    () => getProductOptions(productDetails.options),
    [productDetails]
  );
  const sizeGuideType = useMemo(
    () => getSizeGuideType(tagData, sizes),
    [tagData, sizes]
  );
  if (visibility) {
    document.querySelector("body").classList.add("disable-scroll");
  }
  return (
    <>
      <PopUp onClose={(e, f) => popupCloseHandler(e, f)} show={visibility} closeIcon={true} wrapperClass="quick-buy-popup">
        <div className="first_row">
          <Srcset src={productImage} className="product_image" />
          <div className="mt-15 product_details">
            <div className="small-xs  mb-5">{productDetails.vendor}</div>
            <div className="x-small-xs">{productDetails.title}</div>
          </div>
        </div>
        <div className="typography-wrap">
          <div className="custom-dropdown open">
            {!wishlistComp && <div className="dropdown-lable x-small-xs">
              {selected ? dropdownTitle.charAt(0).toUpperCase() + dropdownTitle.slice(1) + " selected : " + active : "Select your " + dropdownTitle}
            </div>}
            <div className="dropdown-list">
              <ul className="dropdown-ul">
                {data.map((element, index) => {
                  return (<li className={`${type == "color" ? "color" : ""}`} key={index} onClick={(e) => {
                    selectHandler(e, element);
                  }}>
                    {type == "color" && hexCodeArray[index] && hexCodeArray[index].length && <div className="swatches-item">
                      <label className={`${element == active ? styles.active : ""}`}>
                        <span className={`swatches-type ${commonStyle.main}`} style={{ backgroundColor: `#${hexCodeArray[index][0]}` }}></span>
                      </label>
                    </div>}
                    {type == "color" && !hexCodeArray[index] && <div className="swatches-item">
                      <label className={`${element == active ? styles.active : ""}`}>
                        <span className={`swatches-type ${commonStyle.main}`}></span>
                      </label>
                    </div>}
                    <span> {element}</span>
                  </li>)
                })}
              </ul>
            </div>
            {
              type == "size" &&
              <div className="sizeguide_wrapper">
                <SizeGuidePopUp sizeGuideType={sizeGuideType} className="xx-small-xs" isClose={true} plp={true}/>
              </div>
            }
          </div>
        </div>
        <div><button
          type="button"
          className={`${wishlistComp ? "wishlist_cta_text" : ""} btn-primary btn_loading ${styles["add-to-bag-btn"]} ${loading ? "loading" : ""}`}
          onClick={() => {
            if (!loading && selected) {
              setLoading(true);
              fireWishlistAction(selected);
            }
          }}
        >
          <span className="small-xs">{buttonCTA}</span>
        </button></div>
      </PopUp>
    </>
  );
};

export default PLPWishlistMobile;